import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/general/Home";
import Footer from "./components/Footer";
import "./App.css";
import Products from "./pages/general/Products";
import Contact from "./pages/general/Contact";
import Login from "./pages/auth/Login";
import Registration from "./pages/auth/Registration";
import Basket from "./pages/pay/Basket";
import Admin from "./pages/admin/Admin";
import NotFound from "./pages/general/NotFound";
import AdminNewProduct from "./pages/admin/AdminNewProduct";
import { UserProvider } from "./configs/UserContext";
import ProtectedAdminRoute from "./configs/ProtectedAdminRoute";
import ProductDetail from "./pages/general/ProductDetail";
import AdminNewCategory from "./pages/admin/AdminNewCategory";
import AdminEditProduct from "./pages/admin/AdminEditProduct";
import AdminDelivery from "./pages/admin/AdminDelivery";
import Account from './pages/auth/Account';
import Guides from "./pages/general/Guides";
import PaySuccess from "./pages/pay/PaySuccess";
import PayCancel from "./pages/pay/PayCancel";
import PayCODSuccess from "./pages/pay/PayCODSuccess";
import PayError from "./pages/pay/PayError";
import AdminOrders from "./pages/admin/AdminOrders";
import ForgotPassword from "./pages/auth/ForgotPassword";
import NewPassword from "./pages/auth/NewPassword";
import ValidateEmail from "./pages/auth/ValidateEmail";
import { Toaster } from "react-hot-toast";
import Cookies from "./components/Cookies";
import DeliveryInfo from "./pages/general/DeliveryInfo";
import AnalyticsHandler from "./configs/AnalyticsHandler";
import { Helmet } from "react-helmet-async";



function App() {

  return (
    <UserProvider>
      <Toaster position="top-center"/>
      <Helmet>
        <title>Kreatív Örömök</title>
        <meta name="description" content="Kézműves webshop alapanyagokkal, kreatív csomagokkal és egyedi termékekkel. Alkoss, ajándékozz és inspirálódj a Kreatív Örömöknél!" />
      </Helmet>
      <BrowserRouter>
        <AnalyticsHandler/>
        <Cookies/>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/admin/adminsettings" element={<ProtectedAdminRoute component={<Admin />} />} />
          <Route path="/admin/newproduct" element={<ProtectedAdminRoute component={<AdminNewProduct />} />} />
          <Route path="/admin/products/edit/:tableName/:productId" element={<ProtectedAdminRoute component={<AdminEditProduct />} />} />
          <Route path="/admin/newcategory" element={<ProtectedAdminRoute component={<AdminNewCategory />} />} />
          <Route path="/admin/deliverysettings" element={<ProtectedAdminRoute component={<AdminDelivery />} />} />
          <Route path="/admin/orders" element={<ProtectedAdminRoute component={<AdminOrders />} />} />

          <Route path="/products/:tableName/:slugUUID" element={<ProductDetail/>} />
          <Route path="/products/:tableName" element={<Products/>} />
          <Route path="/login" element={<Login />} />
          <Route path="/account" element={<Account />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route path="/new_password/:token" element={<NewPassword />} />
          <Route path="/validate_email/:token" element={<ValidateEmail />} />

          <Route path="/contact" element={<Contact />} />
          <Route path="/basket" element={<Basket />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/successpay" element={<PaySuccess />} />
          <Route path="/paycodsuccess" element={<PayCODSuccess />} />
          <Route path="/cancelpay" element={<PayCancel />} />
          <Route path="/errorpay" element={<PayError />} />
          <Route path="/deliveryinfo" element={<DeliveryInfo />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
        <Footer />
       
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
